import { ChannelTabTypes } from "@bezoned/shared/constants/channel-tab-type.js";
import { MenuItem } from "@fluentui/react-components";
import {
  AddSquareRegular,
  ArrowClockwiseRegular,
  ChannelShareRegular,
  ChatRegular,
  ClipboardTaskListLtrRegular,
  FolderOpenRegular,
  LinkRegular,
  NotebookRegular,
  SettingsRegular,
  WhiteboardRegular,
} from "@fluentui/react-icons";
import { useMemo } from "react";

interface ContextMenuItemProps {
  label: string;
  type: string;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  loading: boolean;
}

export const ContextMenuItem = ({
  label,
  type,
  onClick,
  loading,
}: ContextMenuItemProps) => {
  const Icon = useMemo(() => {
    switch (type) {
      // ! posts are not tabs per say, but it simplifies the code above :/
      case "posts": {
        return ChatRegular;
      }
      // ! channel is a special case for linking to a channel
      case "channel": {
        return ChannelShareRegular;
      }
      case ChannelTabTypes.Files: {
        return FolderOpenRegular;
      }
      case ChannelTabTypes.Notes: {
        return NotebookRegular;
      }
      case ChannelTabTypes.Whiteboard: {
        return WhiteboardRegular;
      }
      case ChannelTabTypes.Planner: {
        return ClipboardTaskListLtrRegular;
      }
      // ! add is a special case for adding new boards
      case "add": {
        return AddSquareRegular;
      }
      case "settings": {
        return SettingsRegular;
      }
      default: {
        return LinkRegular;
      }
    }
  }, [type]);

  return (
    <MenuItem
      className="!text-bzd-gray-500 !hover:bg-bzd-gray-50 !hover:text-bzd-purple-500 !items-center !font-normal !transition-colors !ease-in-out"
      content={{ className: "flex items-center" }}
      icon={
        loading ? (
          <ArrowClockwiseRegular className="text-bzd-purple-500 size-5 animate-spin" />
        ) : (
          <Icon className="size-5" />
        )
      }
      onClick={onClick}
    >
      {label}
    </MenuItem>
  );
};
